import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

interface CommonModalProps {
  title: string;
  message: string;
  show: boolean;
  onHide: () => void;
}

const CommonModal: React.FC<CommonModalProps> = ({
  title,
  message,
  show,
  onHide,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-center">
        <img src="/assets/imgs/done.svg" alt="" />
        <h1>{title}</h1>
        <p>{message}</p>
        <br />
        <Button className="closeBtn" variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;
